const SYNTHETIC_AUTO_MODEL_ID = 'auto';

export const isLlmCatalogueReady = (modelIds: string[]): boolean =>
  modelIds.some((id) => id !== SYNTHETIC_AUTO_MODEL_ID);

export const resolveConversationModelName = (
  participantKeys: string[] | undefined,
  modelIds: string[],
): string | undefined => {
  if (!participantKeys?.length || !isLlmCatalogueReady(modelIds)) {
    return undefined;
  }

  return participantKeys.find((key) => modelIds.includes(key) && key !== SYNTHETIC_AUTO_MODEL_ID)
    ?? participantKeys.find((key) => modelIds.includes(key));
};

export const resolveDropdownModelId = ({
  conversationModelName,
  invitationParticipantIds,
  modelIds,
  catalogueReady,
}: {
  conversationModelName?: string;
  invitationParticipantIds?: string[];
  modelIds: string[];
  catalogueReady: boolean;
}): string | undefined => {
  const fromParticipants = resolveConversationModelName(invitationParticipantIds, modelIds);

  if (!catalogueReady && !fromParticipants) {
    return undefined;
  }

  const modelName = fromParticipants || conversationModelName || '';
  if (modelName === SYNTHETIC_AUTO_MODEL_ID || modelIds.includes(modelName)) {
    return modelName;
  }

  return SYNTHETIC_AUTO_MODEL_ID;
};
